import React from "react"

// Styles
import "./Eiswagen.scss"

// Component
import EisGalleryNeu from "./EisGalleryNew/Carouselnew"

// Img
import EisCharlieImg from "../../images/eis_charlie.png"
import EisCharlieImgWebP from "../../images/eis_charlie.webp"
import Badge from "../../images/Charlie-badge.svg"

const Eiswagen = () => {
  return (
    <section
      id="eiswagen"
      className="eiswagen-container my-container max-width-960"
    >
      <h2 className="headline">Eiswagen</h2>
      <p>
        Das Urgestein der mobilen Eiskultur, Eis Charlie, liefert feinstes
        Speiseeis aus täglich frischer Herstellung. Mit seinem Eiswagen
        beliefert er private Feiern, Firmenevents, Restaurants und Eisdielen im
        Raum Hamburg. Eis Charlie versüßt jede Veranstaltung und sorgt für eine
        entspannte und leckere Auszeit!
      </p>
      <picture>
        <source srcSet={EisCharlieImgWebP} type="image/webp" />
        <img src={EisCharlieImg} alt="Eis Charlie" />
      </picture>
      <img className="badge" src={Badge} />
      <p>
        Seit 30 Jahren stellen wir unser Qualitätseis mit großer Leidenschaft
        und auf traditionellem Wege her. Nicht nur die Qualität der verwendeten
        Rohstoffe und der unvergleichbare Geschmack, auch die Vielfalt unserer
        Eissorten zeichnen unser Eisangebot aus.
      </p>
      <EisGalleryNeu />
    </section>
  )
}

export default Eiswagen
